'use client';

import {FaqAssetFieldsFragment} from '@common/hygraph-schema';
import {Asset, SafeHTML} from '../../atoms';
import {Text, Stack} from '@eds-web/react';
import {useMediaQuery} from '@/hooks';
import {css} from '@panda/css';
import {AnalyticEventProps} from '@/types';

//tbd move to hygraph
const analytics: AnalyticEventProps = {
	eventCategory: 'video',
	eventAction: 'watchVideo',
	eventLabel: 'How To Redeem Video',
	eventValue: {
		component: 'VerifyStep',
		section: 'faq',
		subView: 'Enter Code',
		interactedElement: 'Video'
	}
};

const rootStyle = css({
	flexDirection: 'column',
	alignItems: 'start',
	gap: '24px'
});

const textContainerStyle = css({maxWidth: '350px'});

export const FaqAsset = ({asset, title, desc}: FaqAssetFieldsFragment) => {
	const isMobile = useMediaQuery('sm');

	return (
		<Stack
			align="center"
			gap={isMobile ? 24 : 48}
			direction="row"
			noWrap={isMobile ? false : true}
			className={rootStyle}>
			{asset && (
				<Asset
					disableAutoplay
					className={css({
						borderRadius: '16px',
						aspectRatio: '16 / 9',
						width: {base: '477px', smDown: '100%'}
					})}
					asset={asset.media}
					analytics={analytics}
				/>
			)}

			<Stack gap={4} direction="column" className={textContainerStyle}>
				<Text variant={isMobile ? 'headingMD' : 'headingLG'}>{title}</Text>
				<Text variant="paragraphSM" color="secondary" className="nested-link">
					{desc && <SafeHTML dangerouslySetInnerHTML={{__html: desc.html}} />}
				</Text>
			</Stack>
		</Stack>
	);
};
